var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSurveying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n\t.st2{fill:none;}\r\n\t.st3{fill:#222A2D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.93,33.27c0-0.28-0.22-0.5-0.5-0.5h-1.5c-0.27,0-0.5,0.22-0.5,0.5s0.23,0.5,0.5,0.5h1.5 C23.71,33.77,23.93,33.55,23.93,33.27z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.09,
    y: 45.59,
    className: "st0",
    width: 5.82,
    height: 4.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.09,
    y: 36.3,
    className: "st0",
    width: 5.82,
    height: 4.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.14,32.77c-0.27,0-0.5,0.22-0.5,0.5s0.23,0.5,0.5,0.5h1.71c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5 H25.14z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.89,
    y: 1.5,
    className: "st0",
    width: 3.74,
    height: 33.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.81,
    y: 27.43,
    className: "st0",
    width: 4.38,
    height: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.44,10.37v16.06h0.87h5.38h0.87V10.37h-1.53v3.76h-4.06v-3.76H22.44z M26.01,16.65 c0.98,0,1.76,0.78,1.76,1.76c0,0.98-0.78,1.76-1.76,1.76c-0.98,0-1.78-0.78-1.78-1.76C24.23,17.43,25.04,16.65,26.01,16.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.81,27.43h-0.87c-0.28,0-0.5-0.22-0.5-0.5v-0.97h-2.81v4.27h4.18V27.43z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34.37,
    y: 1.5,
    className: "st0",
    width: 3.74,
    height: 33.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.44,9.87c0-0.28,0.22-0.5,0.5-0.5h8.12c0.28,0,0.5,0.22,0.5,0.5v0.97h2.81V1.5H18.63v9.34h2.81V9.87z  M21.94,3.03h8.12c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5h-8.12c-0.28,0-0.5-0.22-0.5-0.5S21.66,3.03,21.94,3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.06,32.77h-1.5c-0.28,0-0.5,0.22-0.5,0.5s0.22,0.5,0.5,0.5h1.5c0.27,0,0.5-0.22,0.5-0.5 S30.33,32.77,30.06,32.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.56,26.93c0,0.28-0.22,0.5-0.5,0.5h-0.87v2.8h4.18v-4.27h-2.81V26.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.67,21.4v8.25h2.23v6.15c0,0.28,0.22,0.5,0.5,0.5h4.74h3.96v4.09h-2.55v5.18h2.55V51 c0,0.28,0.22,0.5,0.5,0.5h6.82c0.28,0,0.5-0.22,0.5-0.5v-5.43h2.55v-5.18h-2.55V36.3h3.96h4.74c0.28,0,0.5-0.22,0.5-0.5v-6.15h2.23 V21.4h-2.23v-6.44h2.23V6.71h-2.23V1c0-0.28-0.22-0.5-0.5-0.5h-4.74H18.13h-4.74c-0.28,0-0.5,0.22-0.5,0.5v5.71h-2.23v8.25h2.23 v6.44H10.67z M34.37,1.5h3.74v33.8h-3.74V1.5z M21.93,33.77c-0.27,0-0.5-0.22-0.5-0.5s0.23-0.5,0.5-0.5h1.5 c0.28,0,0.5,0.22,0.5,0.5s-0.22,0.5-0.5,0.5H21.93z M28.03,14.14v-3.76h1.53v16.06h-0.87h-5.38h-0.87V10.37h1.53v3.76H28.03z  M23.81,30.23v-2.8h4.38v2.8H23.81z M27.35,33.27c0,0.28-0.22,0.5-0.5,0.5h-1.71c-0.27,0-0.5-0.22-0.5-0.5s0.23-0.5,0.5-0.5h1.71 C27.13,32.77,27.35,32.99,27.35,33.27z M28.91,50.5h-5.82v-4.91h5.82V50.5z M28.91,40.37h-5.82V36.3h5.82V40.37z M30.06,33.77h-1.5 c-0.28,0-0.5-0.22-0.5-0.5s0.22-0.5,0.5-0.5h1.5c0.27,0,0.5,0.22,0.5,0.5S30.33,33.77,30.06,33.77z M33.37,30.23h-4.18v-2.8h0.87 c0.28,0,0.5-0.22,0.5-0.5v-0.97h2.81V30.23z M18.63,1.5h14.74v9.34h-2.81V9.87c0-0.28-0.22-0.5-0.5-0.5h-8.12 c-0.28,0-0.5,0.22-0.5,0.5v0.97h-2.81V1.5z M18.63,25.96h2.81v0.97c0,0.28,0.22,0.5,0.5,0.5h0.87v2.8h-4.18V25.96z M13.89,1.5h3.74 v33.8h-3.74V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.01,20.16c0.98,0,1.76-0.78,1.76-1.76c0-0.98-0.78-1.76-1.76-1.76c-0.98,0-1.78,0.78-1.78,1.76 C24.23,19.38,25.04,20.16,26.01,20.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.94,4.03h8.12c0.28,0,0.5-0.22,0.5-0.5s-0.22-0.5-0.5-0.5h-8.12c-0.28,0-0.5,0.22-0.5,0.5 S21.66,4.03,21.94,4.03z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveying);
export default __webpack_public_path__ + "static/media/surveying.a95d1a1b789377abf66af3c2717efad5.svg";
export { ForwardRef as ReactComponent };